module.exports = __webpack_public_path__ + "img/qualification-certification.07b1d5ff.png";